import {
  EcommerceAnalyticsAction,
  LOAD_ECOMMERCE_ANALYTICS,
  LOAD_ECOMMERCE_ANALYTICS_FAIL,
  LOAD_ECOMMERCE_ANALYTICS_SUCCESS,
  LoadEcommerceAnalytics,
  LoadEcommerceAnalyticsFail,
  LoadEcommerceAnalyticsSuccess
} from "../actions";

export interface IEcommerceAnalyticsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceAnalyticsState {
  entities: { [websiteId: number]: IEcommerceAnalyticsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceAnalyticsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceAnalyticsState = initialState, action: EcommerceAnalyticsAction): IEcommerceAnalyticsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_ANALYTICS:
      payload = (<LoadEcommerceAnalytics>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_ANALYTICS_SUCCESS:
      payload = (<LoadEcommerceAnalyticsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_ANALYTICS_FAIL:
      payload = (<LoadEcommerceAnalyticsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
